import React, { Component } from 'react'
import { connect } from 'react-redux'

import _ from 'lodash'
import yn from 'yn'
import renderHTML from 'react-render-html'

if (yn(process.env.REACT_APP_COMPONENT_PARTNERS_BENEFITS_BANNER)) {
	require('../../styles/css/components/partners/bk-flow-partners-banner.css')
}

class BkFlowPartnersBenefitsBanner extends Component{
	render() {
		const {
			urlData,
			availabilityData,
			disableLogo
		} = this.props

		let renderPartnersBanner = [],
				renderPartnersEntries = [],
				renderPartnersTitle = null,
				renderPartnersLogo = null

		if (
			urlData &&
			urlData.promoCode &&
			!_.isEmpty(availabilityData) &&
			_.get(availabilityData, '[0][0].basicPropertyInfo.viewExtensions.partners')
		) {
			const brandPartners = availabilityData[0][0].basicPropertyInfo.viewExtensions.partners,
						activePartner = brandPartners.filter(function(partner) {
							return partner.ratePlanId === urlData.promoCode
						})

			if (
				activePartner &&
				activePartner[0] &&
				activePartner[0].title !== ''
			) {
				renderPartnersTitle = activePartner[0].title
			}

			if (
				activePartner &&
				activePartner[0] &&
				activePartner[0].logos &&
				activePartner[0].logos.dark !== ''
			) {
				renderPartnersLogo = activePartner[0].logos.dark
			}

			if (
				activePartner &&
				activePartner[0] &&
				activePartner[0].benefits &&
				!_.isEmpty(activePartner[0].benefits)
			) {
				const partnerBenefits = activePartner[0].benefits

				for (const benefitKey in partnerBenefits) {
					const currentBenefit = partnerBenefits[benefitKey]

					renderPartnersEntries.push(
						<div
							key={ 'partner-benefit-' + currentBenefit.title}
							className="bk-flow__partners-banner-entry"
						>
							{ currentBenefit.image &&
								currentBenefit.image.path &&
									<div className="bk-flow__partners-banner-entry-image">
										{ renderHTML(currentBenefit.image.path)}
									</div>
							}

							{ currentBenefit.title &&
								<div className="bk-flow__partners-banner-entry-content">
									<p className="u-remove-margin u-font-bold">{ currentBenefit.title }</p>
									{ currentBenefit.content && <p className="u-remove-margin">{ currentBenefit.content }</p> }
								</div>
							}
						</div>
					)
				}

				renderPartnersBanner.push(
					<div
						key={ 'partner-banner-'}
						className="bk-flow__partners-banner"
					>
						{ renderPartnersTitle &&
							<h5>{ !disableLogo && renderPartnersLogo && <div className="bk-flow__partners-banner-logo">{renderHTML(renderPartnersLogo)}</div> }{renderPartnersTitle}</h5>
						}

						<div className="bk-flow__partners-banner-benefits">
							{ renderPartnersEntries }
						</div>
					</div>
				)
			}
		}

		return renderPartnersBanner
	}
}

function mapStateToProps(state) {
	return {
		urlData: state.availabilityData.urlData,
		availabilityData: state.availabilityData.availability
	}
}

export default connect(mapStateToProps, null)(BkFlowPartnersBenefitsBanner)


// WEBPACK FOOTER //
// ./src/components/partners/BkFlowPartnersBenefitsBanner.js